// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"81":"dist/css/editor","799":"dist/css/home","883":"dist/css/admin","921":"dist/css/main","954":"dist/css/spa-form-styling"}[chunkId] + ".css";
};